export default __webpack_public_path__ + "static/media/0131.9b038774.jpg";